module.exports = __webpack_public_path__ + "static/bootstrap-table-basic-6bb56b0b9f0f4d0a6bb352600f43e628.png";